import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24RetryG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9.845 1.803a.746.746 0 0 0 .076.992l1.37 1.323-.23.015a9.47 9.47 0 0 0-4.71 1.699c-2.02 1.421-3.348 3.52-3.736 5.91-.803 4.932 2.692 9.572 7.784 10.347q.727.111 1.457.111c4.565 0 8.512-3.23 9.23-7.641.53-3.256-.813-6.537-3.504-8.561a.78.78 0 0 0-1.073.132.746.746 0 0 0 .137 1.069c2.242 1.686 3.36 4.415 2.92 7.12-.669 4.103-4.673 6.92-8.93 6.276-4.254-.648-7.167-4.514-6.5-8.614.323-1.988 1.428-3.734 3.113-4.92l.28-.188a7.9 7.9 0 0 1 3.743-1.241l.162-.009-1.513 1.463a.746.746 0 0 0 0 1.078.78.78 0 0 0 1.081 0L13.966 5.3a.5.5 0 0 0 .012-.707l-2.976-2.876a.78.78 0 0 0-1.08 0z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24RetryG$1 = Svg24RetryG;

export { Svg24RetryG$1 as default };
